import axios from 'axios';

export default axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}api/v1/web`,
	//   headers: {
	//     "Content-type": "application/json"
	//   }
});
